/**
 * <Currency />
 *
 * NOTE: we're using currency data inside data/currency.js instead of having 
 * a detached currency file for this form. 
 *
 * @parent anybody
 * @stateful
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'
import currencyData from 'data/currency'
import Select from 'react-select';
import parseJson from '../../parseJson';

export const DEFAULT_CURRENCY = 'USD';

const currencyOptions = currencyData.map((item, idx)=>{
  return {
    label: `${item.name} (${item.symbol})`,
    value: item.code,
  }
});

export function currency(props) {
  const {
    schema,
    onChange,
    options,
    placeholder,
    value,
  } = props;

  const {
    name,
  } = schema;

  const {
    maxlength,
  } = options;

  return (
    <Currency 
      name={name}
      value={value}
      onChange={onChange}
      {...options}
    />
  );
}

class Currency extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      name,
      value,
      onChange,
    } = this.props

    return (
      <div className='currency-wrapper form-input'>
        <Select
          clearable={false}
          name={name}
          value={value}
          onChange={(item)=>{
            onChange(item.value);
          }}
          options={currencyOptions}
        />
      </div>
    ) 
  }
}

export default Currency;



// WEBPACK FOOTER //
// ./src/components/UI/Form/Fields/Currency/index.js